import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import LinkWithIcon from 'components/ui/LinkWithIcon/LinkWithIcon'

import s from './SidebarNavItems.scss'


const SidebarNavItems = ({ items, closeSidebar, changeActiveIndex }) => (
  items.map((item, index) => {
    const { className, onClick, subNav, title, to, toOLD, id, redirect, icon, emojiIcon, isBanner, brandColor, dataTestId } = item

    const itemClassName = cx(s.sideMenuItem, className, {
      [s.withArrow]: subNav || isBanner,
      [s.banner]: isBanner,
      [s.brandColor]: brandColor,
    })

    const handleClick = () => {
      if (typeof onClick === 'function') {
        onClick()
      }

      if (subNav) {
        changeActiveIndex(index)
      }
      else {
        closeSidebar()
      }
    }

    return (
      <LinkWithIcon
        key={index}
        className={itemClassName}
        iconClassName={s.icon}
        id={id}
        title={title}
        icon={icon}
        emojiIcon={emojiIcon}
        to={to}
        toOLD={toOLD}
        redirect={redirect}
        withHtmlTitle={isBanner}
        customColor
        inlineSvg
        onClick={handleClick}
        dataTestId={dataTestId}
      />
    )
  })
)

SidebarNavItems.propTypes = {
  items: PropTypes.array.isRequired,
  closeSidebar: PropTypes.func.isRequired,
  changeActiveIndex: PropTypes.func.isRequired,
}


export default SidebarNavItems
